import { useEffect, useState, useRef } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./../../Calendar/Calendar.css"
import { format, parse } from 'date-fns';
import './NewTabletBookingForm.css';
import { ErrorAlert } from '../../crud/utils';
import useApp from '../../AppContext';
import { getCultureInfo } from "../../crud/utils";
import DynamicDatePicker from "../../Components/DynamicDatePicker";
import { loadListAllObjects, loadFormObject, postBooking, loadDataObject, loadEditObject, getBookingSuppliers, getPorders, getBookingTasks, getDropdownLookupList } from "../../Calendar/CalendarUtils";
import { getPropValue, setPropValue, createGql, callApi } from '../../crud/utils';
import TabletSuccMessage from "../Components/TabletSuccMessage";
import PhotoUpload from "../Components/PhotoUpload";
import AutoCompleteOneOutPut from "../../crud/AutoCompleteOneOutPut";
import PaginationControls from "../../Components/PaginationControls";
import { t } from "./../../i18n"
import Loading from "../../Loading";
import CustomDropdown from "../../Components/CustomDropdown";

function EditBookingForm(props) {
    const app = useApp();
    const photoUploadRef = useRef(null);
    const handleSaveBookingRef = useRef(null);
    const [gridTop] = useState(app.gridTop);
    const [serverUrl] = useState(app.serverUrl);
    const [userid] = useState(app.sessionToken?.UserId);
    const [language] = useState(getCultureInfo(app.sessionToken?.Language));
    const [allColumnsObj, setAllColumnsObj] = useState({});
    const [bookingObj, setBookingObj] = useState({})
    const [isLoadObj, setIsLoadObj] = useState(false);
    const [lookUpInfo, setLookUpInfo] = useState(null);
    const [titleValue] = useState(t("entryWithBooking.successTitle", language));
    const [btnSuccessScreenValue] = useState(t("entryWithBooking.nextEntry", language));
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(null);
    const [licenseNo, setLicenseNo] = useState([]);
    const [showMatchingDropdown, setShowMatchingDropdown] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3;
    const [isLoading, setIsLoading] = useState(true);
    const [hasDriverBan, setHasDriverBan] = useState(false);

    useEffect(() => {
        if (props.saveTriggered > 0) {
            handleSaveBookingRef.current?.();
        }
    }, [props.saveTriggered]);

    const totalPages = Math.ceil(licenseNo.length / itemsPerPage);
    const paginationLicenseNo = licenseNo.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    useEffect(() => {
        setCurrentPage(1);
    }, [licenseNo]);

    const handleImagesChange = (uploadedPath) => {
        setBookingObj(prev => {
            const copy = { ...(prev || {}) };
            if (!copy.Obj) copy.Obj = {};
            copy.Obj.PhotoPath = uploadedPath;
            return copy;
        });
    };
    useEffect(() => {
        async function getDefaultLayouts() {
            if (!serverUrl) return;
            setIsLoading(true);
            try {
                if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) {
                    let allobj = await loadListAllObjects(serverUrl, props.userToken)
                    if (allobj) {
                        setAllColumnsObj(allobj);
                        setIsLoadObj(true);
                    }
                    const layoutBooking = await loadFormObject(serverUrl, props.userToken, "Yms_Booking");
                    if (layoutBooking) {
                        const retLookupList = await getDropdownLookupList(serverUrl, props.userToken, layoutBooking);
                        if (retLookupList) {
                            setLookUpInfo(prev => {
                                prev = { ...prev };
                                prev["Yms_Booking"] = retLookupList;
                                return prev;
                            });
                        }
                    }
                    const layoutBookTasks = await loadFormObject(serverUrl, props.userToken, "Yms_BookingTasks");
                    if (layoutBookTasks) {
                        const retLookupList = await getDropdownLookupList(serverUrl, props.userToken, layoutBookTasks);
                        if (retLookupList) {
                            setLookUpInfo(prev => {
                                prev = { ...prev };
                                prev["Yms_BookingTasks"] = retLookupList;
                                return prev;
                            });
                        }
                    }
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        }
        getDefaultLayouts();
    }, [serverUrl, props.userToken, allColumnsObj]);

    useEffect(() => {
        async function getYmsBooking() {
            if (!props.bookingId) return;
            const objectName = "Yms_Booking";
            if (Object.keys(allColumnsObj).length === 0) return;
            let defaultVariables = {
                "instanceName": "m_yms_booking",
                "filterName": "customfilter",
                "dontCash": "true"
            }
            let prms = [];
            let prmValues = {};
            if (props.actions === "NewBoocking") {
                defaultVariables["createNewRow"] = "true";
            }
            else {
                defaultVariables["appendFilter"] = "{BookingId} =?(;n;15;p_BookingId) ";
                prms.push({ "parameterName": "p_BookingId", "type": "" });
                prmValues["p_BookingId"] = Number(props.bookingId || 0);
            }
            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
            if (result.data[objectName]) {
                let resultobj = result.data[objectName];
                if (props.actions === "NewBoocking") {
                    const localDate = (props.selectTtimeSlot) ? props.selectTtimeSlot : new Date();
                    const localString = format(localDate, "yyyy-MM-dd'T'HH:mm")
                    resultobj[0]["WarehouseId"] = props.warehouseid;
                    resultobj[0]["InDate"] = localString;
                    resultobj[0]["FromDate"] = localString;
                    resultobj[0]["BookingUserId"] = userid;
                    resultobj[0]["Yms3plId"] = props.supplierData.Yms3plId
                    resultobj[0]["Yms3pl1"] = props.supplierData.Yms3pl1
                    setBookingObj({});
                }

                let objEdit = {
                    Obj: resultobj[0],
                    rowRestrictions: result.rowRestrictions,
                    disabledFields: result.disabledFields
                }
                const resYmsBsu = await getBookingSuppliers(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsBsu) {
                    objEdit["Yms_BookingSuppliers"] = resYmsBsu;
                }
                const resYmsPor = await getPorders(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsPor) {
                    objEdit["Yms_Porders"] = resYmsPor;
                }
                const YmsBta = await getBookingTasks(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (YmsBta) {
                    objEdit["Yms_BookingTasks"] = YmsBta;
                }

                // Check driver ActiveFlg after booking is loaded
                if (objEdit.Obj?.DriverId) {
                    try {
                        const driverObjectName = "Yms_Drivers";
                        let driverPrms = [{ "parameterName": "p_DriverId", "type": "" }];
                        let driverPrmValues = { "p_DriverId": Number(objEdit.Obj.DriverId) };
                        let driverDefaultVariables = {
                            "instanceName": "m_yms_drivers",
                            "filterName": "customfilter",
                            "appendFilter": "{DriverId} =?(;n;15;p_DriverId)",
                            "dontCash": "true"
                        };

                        const driverResult = await loadEditObject(serverUrl, props.userToken, allColumnsObj[driverObjectName], driverPrms, driverPrmValues, driverDefaultVariables);
                        const driver = driverResult?.data?.[driverObjectName]?.[0];
                        const isActive = driver?.ActiveFlg === true || driver?.ActiveFlg === 1;

                        if (driver && !isActive) {
                            const driverName = objEdit.Obj?.YmsDri1?.Name1 || "Unknown";
                            setError(t('tablet.driverBanWarning', language).replace('{{driverName}}', driverName));
                            setHasDriverBan(true);
                        } else {
                            setHasDriverBan(false);
                        }
                    } catch (err) {
                        console.error("Error checking driver ActiveFlg on load:", err);
                    }
                }

                setBookingObj(objEdit)
            }
        }
        getYmsBooking();
    }, [allColumnsObj, props.setBookingId, serverUrl, userid, language, props.supplierData, props.warehouseid, props.actions, props.selectTtimeSlot, app.sessionToken, props.userToken, props.bookingId]);

    const fetchLicenseNo = async (LicenseNo) => {
        if (!LicenseNo || Object.keys(allColumnsObj).length === 0) return;

        const objectName = "Yms_Booking";
        const today = format(new Date(), 'yyyy-MM-dd');

        const prms = [
            { parameterName: "p_LicenseNo", type: "" },
            { parameterName: "p_TodayDate", type: "" },
            { parameterName: "p_WarehouseId", type: "" }
        ];

        const prmValues = {
            p_LicenseNo: LicenseNo,
            p_TodayDate: today,
            p_WarehouseId: app.sessionToken.WarehouseId
        };

        const defaultVariables = {
            filterName: "customfilter",
            top: 50,
            appendFilter: `
                YmsTrk1.LicenseNo = ?(;s;12;p_LicenseNo)
                AND TRUNC(FromDate) = TO_DATE(?(;s;10;p_TodayDate), 'YYYY-MM-DD')
                AND {YmsBok.WarehouseId} =?(;n;5;p_WarehouseId)
                 AND Status = 5
            `
        };

        setShowMatchingDropdown(false);

        const responseObj = await loadDataObject(
            serverUrl,
            props.userToken,
            objectName,
            allColumnsObj,
            prms,
            prmValues,
            defaultVariables
        );
        if (responseObj) {
            setLicenseNo(responseObj);
            setShowMatchingDropdown(true);
        }
    };

    // async function addTask() {
    //     const objectName = "Yms_BookingTasks";
    //     let prms = [];
    //     let prmValues = {};
    //     const parentSelectedRow = bookingObj.Obj;
    //     let defaultVariables = {
    //         "instanceName": "m_yms_booking",
    //         "dontCash": "true"
    //     }
    //     defaultVariables["createNewRow"] = "true";
    //     defaultVariables["parentSelectedRow"] = parentSelectedRow;
    //     const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
    //     if (result.data[objectName]) {

    //         setBookingObj(prev => {
    //             prev = { ...prev }
    //             if (!prev[objectName]) prev[objectName] = [];
    //             else prev[objectName] = [...prev[objectName]];
    //             prev[objectName].push(result.data[objectName][0]);
    //             return prev;
    //         });
    //     }
    // };
    const deleteTask = (rowIndex) => {
        let tmpbookingObj = { ...bookingObj }
        tmpbookingObj["Yms_BookingTasks"].splice(rowIndex, 1)
        setBookingObj(tmpbookingObj);
    };
    async function handleSaveBooking(e) {
        if (!bookingObj?.Obj?.TruckId) {
            setError(t("tablet.noTruckError", language));
            return;
        }
        if (!bookingObj?.Obj?.DriverId) {
            setError(t("tablet.noDriverError", language));
            return;
        }
        if (hasDriverBan) {
            setError(t('tablet.cannotSaveWithBannedDriver', language));
            return;
        }
        if (!bookingObj["Yms_BookingTasks"] || bookingObj["Yms_BookingTasks"].length === 0) {
            setError(t("tablet.noTaskError", language));
            return;
        }
        if (props.bookingId === null || isNaN(props.bookingId)) return setError(t('tablet.noBookingSelected', language));
        e?.preventDefault();
        try {
            const finalPaths = await photoUploadRef.current?.applyPendingChanges();
            setError(null);
            let tmpbookingObj = { ...bookingObj };
            if (!tmpbookingObj["Obj"]) tmpbookingObj["Obj"] = {};
            tmpbookingObj["Obj"].PhotoPath = finalPaths;
            tmpbookingObj["Obj"].Status = 6;
            setBookingObj(tmpbookingObj);

            const saveobj = await postBooking(serverUrl, props.userToken, "Yms_Booking", "m_yms_booking", tmpbookingObj);
            if (saveobj) {
                setShowModal(true);
                setTimeout(() => {
                    window.location.href = '/tablet-view';
                }, 1700);
            }
        } catch (err) {
            setError(err.message || err);
        }
    }
    handleSaveBookingRef.current = handleSaveBooking;

    function handleCloseModalSuccessMes(e) {
        e?.preventDefault?.();
        setShowModal(false);
    }
    async function setObjectValue(objName, rowIndex, column, value, selectedIndex) {
        let obj = {};

        if (rowIndex === null) {
            obj = { ...bookingObj["Obj"] };
        } else {
            obj = { ...bookingObj[objName][rowIndex] };
        }
        let tmpObj = { ...obj };
        setPropValue(tmpObj, column.columnName, value);

        if (column.columnName === "FromDate") {
            tmpObj["InDate"] = value;
        }

        if (selectedIndex >= 0 && lookUpInfo[objName][column.columnName] && lookUpInfo[objName][column.columnName].keyFields) {
            for (let i = 0; i < lookUpInfo[objName][column.columnName].keyFields.length; i++) {
                let kf = lookUpInfo[objName][column.columnName].keyFields[i];
                if (selectedIndex === 0) {
                    tmpObj[kf.foreignField] = null;
                }
                else {
                    tmpObj[kf.foreignField] = lookUpInfo[objName][column.columnName].values[selectedIndex - 1][kf.primaryField];
                }
            };
        }
        let tmpbookingObj = { ...bookingObj }

        if (rowIndex === null) {
            tmpbookingObj["Obj"] = tmpObj;
        }
        else {
            tmpbookingObj[objName][rowIndex] = tmpObj;
        }
        if (column.columnName === "StampFlg") {
            tmpbookingObj["Obj"].StampFlg = value ? 1 : 0;
        }
        if (column.columnName === "YmsDri1.Name1") {
            tmpbookingObj["Obj"].YmsDri1.DriverCode = value.secondaryField;
            tmpbookingObj["Obj"].DriverId = value.pkField;
            tmpbookingObj["Obj"].YmsDri1.Name1 = value.lkpField;
        }
        if (column.columnName === "YmsTrk1.LicenseNo") {
            tmpbookingObj["Obj"].YmsTrk1.LicenseNo = value.lkpField;
            tmpbookingObj["Obj"].TruckId = value.pkField;
            tmpbookingObj["Obj"].YmsTrk1.Descr1 = value.secondaryField;
        }
        if (column.columnName === "YmsTrk1.LicenseNo" && value === "" && typeof props.setActions === "function") {
            props.setQrInput(null)
            props.setSocialSecurityNo(null)
            setShowMatchingDropdown(false)
            setLicenseNo([])
            props.resetFormState()
        }

        setBookingObj(tmpbookingObj);
    }

    function createTextBox(obj, columnName, objName, rowIndex, disabledFieldsFlg) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        let colValue = getPropValue(obj, column.columnName)
        return <Form.Control
            value={colValue}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.value)}
            readOnly={column.editNotAllowed === true}
            disabled={disabledFieldsFlg}
        />;

    }
    function createTextBoxCommends(obj, columnName, objName, rowIndex) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        let colValue = getPropValue(obj, column.columnName)
        return <Form.Control
            as="textarea"
            rows={6}
            value={colValue}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.value)}
            readOnly={column.editNotAllowed === true}

        />;

    }
    function createDropDownLookUpList(obj, columnName, objName, rowIndex, disabledFieldsFlg) {
        if (!lookUpInfo[objName] || !lookUpInfo[objName][columnName]) return null;
        let column = lookUpInfo[objName][columnName].column;

        const options = lookUpInfo[objName][column.columnName].values.map(lkpObj => ({
            value: lkpObj[column.dropDownDisplay],
            label: lkpObj[column.dropDownDisplay]
        }));

        return (
            <CustomDropdown
                options={options}
                value={getPropValue(obj, column.columnName)}
                onChange={e => setObjectValue(objName, rowIndex, column, e.target.value, e.target.selectedIndex)}
                readonly={column.editNotAllowed === true}
                disabled={disabledFieldsFlg}
                showEmptyOption={true}
                placeholder="Επιλέξτε..."
            />
        );
    }
    function formatDateValue(colValue, format) {
        if (!colValue) return colValue;
        let retVal = colValue;

        //let d = parse(colValue, "dd/MM/yyyy HH:mm", new Date())
        let d = Date(colValue);
        if (!(d instanceof Date) || isNaN(d)) {
            if (retVal.toString().length >= 13) {
                d = new Date(retVal);
            }
            else {
                d = parse(colValue,
                    (format === 'dt') ? "dd/MM/yyyy HH:mm" : (format === 't') ? "HH:mm" : "dd/MM/yyyy",
                    new Date());
            }
        }
        if ((d instanceof Date)) {
            if (format === 'd') {
                return d.getDate().toString().padStart(2, '0') + "/" +
                    (d.getMonth() + 1).toString().padStart(2, '0') + "/" +
                    d.getFullYear();
            }
            else if (format === 't') {
                return d.getHours().toString().padStart(2, '0') + ":" +
                    d.getMinutes().toString().padStart(2, '0');
            }
            else if (format === 'dt') {
                return d.getDate().toString().padStart(2, '0') + "/" +
                    (d.getMonth() + 1).toString().padStart(2, '0') + "/" +
                    d.getFullYear() + " " +
                    d.getHours().toString().padStart(2, '0') + ":" +
                    d.getMinutes().toString().padStart(2, '0');
            }
        }
        return retVal;
    }
    async function addTask() {
        const objectName = "Yms_BookingTasks";
        let prms = [];
        let prmValues = {};
        const parentSelectedRow = bookingObj.Obj;
        let defaultVariables = {
            "instanceName": "m_yms_booking",
            "dontCash": "true"
        }
        defaultVariables["createNewRow"] = "true";
        defaultVariables["parentSelectedRow"] = parentSelectedRow;
        const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
        if (result.data[objectName]) {
            const newTask = {
                ...result.data[objectName][0],
                isNewlyAdded: true // Add this flag for new tasks
            };
            // console.log('New Task Being Added:', {
            //     task: newTask,
            //     bookingId: parentSelectedRow?.BookingId,
            //     timestamp: new Date().toISOString()
            // });

            setBookingObj(prev => {
                prev = { ...prev }
                if (!prev[objectName]) prev[objectName] = [];
                else prev[objectName] = [...prev[objectName]];
                prev[objectName].push(newTask);
                return prev;
            });
        }
    };
    function CreatDatetime(obj, columnName, objName, rowIndex, disabledFieldsFlg) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        let pickerType = (column.format === 'dt') ? "DateTime" : (column.format === 't') ? "Time" : "Date";
        let format = (column.format === 'dt') ? "dd/MM/yyyy HH:mm" : (column.format === 't') ? "HH:mm" : "dd/MM/yyyy";
        return <DynamicDatePicker
            caption=""
            pickerType={pickerType}
            dateFormat={format}
            value={formatDateValue(getPropValue(obj, column.columnName), column.format)}
            onChange={(value) => setObjectValue(objName, rowIndex, column, value)}
            readOnly={column.editNotAllowed === true}
            locale={language}
            disabled={disabledFieldsFlg}
        />;
    }
    function createCheckBox(obj, columnName, objName, rowIndex) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        return <Form.Check
            type="checkbox"
            checked={!!getPropValue(obj, column.columnName)}
            id={column.fieldName}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.checked)}
        />;
    }

    function createAutoCompleteGeneric({
        objName,
        rowIndex,
        disabledFieldsFlg,
        columnConfig,
        objectName,
        instanceName,
        lookupPrimaryField,
        lookupSecondaryField,
        setFieldsInBookingObj
    }) {
        const obj = rowIndex === null
            ? bookingObj["Obj"]
            : bookingObj[objName][rowIndex];

        const primaryVal = getPropValue(obj, columnConfig.columnName) || "";
        const secondaryVal = getPropValue(obj, columnConfig.secondaryField) || "";

        return (
            <AutoCompleteOneOutPut
                key={`${primaryVal}_${secondaryVal}`}
                as="AutoComplete"
                placeholder=""
                serverUrl={serverUrl}
                props={props}
                col={columnConfig}
                obj={{
                    ...obj,
                    [columnConfig.columnName]: primaryVal,
                    [columnConfig.secondaryField]: secondaryVal,
                }}
                onChange={async (e) => {

                    if (e && e.option && columnConfig.columnName === 'YmsDri1.Name1' && e.option.pkField) {
                        const driverName = e.option.lkpField;
                        try {
                            const objectName = "Yms_Drivers";
                            let prms = [{ "parameterName": "p_DriverId", "type": "" }];
                            let prmValues = { "p_DriverId": Number(e.option.pkField) };
                            let defaultVariables = {
                                "instanceName": "m_yms_drivers",
                                "filterName": "customfilter",
                                "appendFilter": "{DriverId} =?(;n;15;p_DriverId)",
                                "dontCash": "true"
                            };

                            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables);
                            const driver = result?.data?.[objectName]?.[0];
                            const isActive = driver?.ActiveFlg === true || driver?.ActiveFlg === 1;
                            if (driver && !isActive) {
                                setError(t('tablet.driverBanWarning', language).replace('{{driverName}}', driverName));
                                setHasDriverBan(true);
                                let tmpbookingObj = { ...bookingObj };
                                tmpbookingObj["Obj"].DriverId = null;
                                tmpbookingObj["Obj"].YmsDri1.Name1 = "";
                                tmpbookingObj["Obj"].YmsDri1.DriverCode = "";
                                setBookingObj(tmpbookingObj);
                                return;
                            }
                            setHasDriverBan(false);
                        } catch (err) {
                            console.error("Error checking driver ActiveFlg:", err);
                        }
                    }

                    if (e && e?.option?.secondaryField === '') {
                        let prms = [];
                        let prmValues = {};
                        const parentSelectedRow = bookingObj.Obj;
                        let defaultVariables = {
                            instanceName: instanceName,
                            dontCash: "true",
                            createNewRow: "true",
                            parentSelectedRow: parentSelectedRow
                        };

                        const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables);
                        const rawData = result?.data?.[objectName]?.[0] || {};
                        let tmprawData = { ...rawData };
                        if (columnConfig.columnName === 'YmsDri1.Name1') {
                            tmprawData[lookupPrimaryField] = e?.option.lkpField;
                            tmprawData.ActiveFlg = true;
                            tmprawData[lookupSecondaryField] = tmprawData.DriverId;
                        } else {
                            tmprawData[lookupPrimaryField] = e?.option.lkpField;
                            tmprawData.ActiveFlg = true;
                            tmprawData[lookupSecondaryField] = `Εκκρεμής ${columnConfig.descr}`;
                        }


                        const gqlCols = createGql("", allColumnsObj[objectName].columns, []);
                        const requestBody = {
                            query: `mutation save${objectName}($obj: ${objectName}!){` +
                                `save${objectName}(${objectName}: $obj) ${gqlCols.query} }`,
                            variables: {
                                obj: {
                                    instanceName: '',
                                    filterName: "default",
                                    top: gridTop,
                                    changedData: [
                                        {
                                            action: "insert",
                                            original: null,
                                            current: tmprawData
                                        }
                                    ]
                                }
                            }
                        };
                        const gqlResult = await callApi('POST', `${serverUrl}/api/query`, props.userToken, requestBody);
                        const newEntry = gqlResult.data[objectName][0];

                        let tmpbookingObj = { ...bookingObj };
                        setFieldsInBookingObj(tmpbookingObj, newEntry);
                        setBookingObj(tmpbookingObj);
                        return;
                    }
                    if (columnConfig.columnName === "YmsTrk1.LicenseNo" && e?.option?.lkpField) {
                        fetchLicenseNo(e.option.lkpField);
                    }
                    setObjectValue(objName, rowIndex, columnConfig, e ? e.option : "");
                }}
            />
        );
    }
    if (isLoading) return <Loading />;
    if (!isLoadObj) return;
    return (
        <>
            <div>
                {showModal && (
                    <div className="modal-container-tablet">
                        <div className="modal-content-container-tablet">
                            <button onClick={handleCloseModalSuccessMes} className='close-btn-modal-tablet'>
                                <i className="bi bi-x-lg"></i>
                            </button>

                            <TabletSuccMessage
                                title={titleValue}
                                paragraph={
                                    <>
                                        {getPropValue(bookingObj.Obj, "ArrivalId") && (
                                            <>
                                                {t("ModalBooking.codeForEntry", language)}: <strong>{getPropValue(bookingObj.Obj, "ArrivalId")}</strong>
                                            </>
                                        )}
                                    </>
                                }
                                btnSuccessScreen={btnSuccessScreenValue}
                            />


                        </div>
                    </div>
                )}
                <>
                    <ErrorAlert message={error} setMessage={setError} language={language} />

                    <Form>
                        <Row className="mb-3">
                            <Col md={9}>
                                <Form.Group>
                                    <Form.Label>{t("ModalBooking.licenseNoTitleForm", language)}  <b className="required-bullet">*</b></Form.Label>
                                    {createAutoCompleteGeneric({
                                        objName: "Yms_Booking",
                                        rowIndex: null,
                                        disabledFieldsFlg: props.disabledFieldsFlg,
                                        columnConfig: {
                                            descr: "πινακίδα",
                                            columnName: "YmsTrk1.LicenseNo",
                                            dropDownDisplay: "LicenseNo",
                                            lookUpQuery: "{Yms_Trucks{TruckId LicenseNo Descr1}}",
                                            secondaryField: "YmsTrk1.Descr1"
                                        },
                                        objectName: "Yms_Trucks",
                                        instanceName: "m_yms_trucks",
                                        lookupPrimaryField: "LicenseNo",
                                        lookupSecondaryField: "Descr1",
                                        setFieldsInBookingObj: (tmpObj, newEntry) => {
                                            tmpObj["Obj"].YmsTrk1.LicenseNo = newEntry.LicenseNo;
                                            tmpObj["Obj"].TruckId = newEntry.TruckId;
                                            tmpObj["Obj"].YmsTrk1.Descr1 = newEntry.Descr1;
                                        }
                                    })}
                                </Form.Group>
                            </Col>
                            <Col md={3} className="d-flex align-items-end">
                                <button type="button" className="btn btn-tablet-color w-100 mb-2" disabled>
                                    <i className="bi bi-upc-scan"></i> {t("entryWithBooking.scanButton", language)}
                                </button>
                            </Col>
                        </Row>
                        {licenseNo.length > 0 && showMatchingDropdown && !props.disabledFieldsFlg && (
                            <>
                                <div className="mt-2 mb-2 border rounded p-2" style={{ backgroundColor: app.theme === 'dark' ? '#3a3d40' : '#f8f9fa' }}>
                                    <h5 style={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>{t("entryWithBooking.availableBookings", language)}</h5>
                                    {paginationLicenseNo.map((item, idx) => (
                                        <div
                                            key={idx}
                                            onClick={() => {
                                                props.setBookingId(item?.BookingId);
                                                props.setQrInput(item?.ArrivalId || '');
                                                props.setSocialSecurityNo(item?.SupDescr || '');
                                                props.setActions("EditBoocking");
                                                setShowMatchingDropdown(false);
                                                props.setDisabledFieldsFlg(true);
                                            }}
                                            className="p-2 mb-1 rounded border shadow-sm"
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: app.theme === 'dark' ? 'var(--bg-tertiary)' : '#fff',
                                                color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit',
                                                borderColor: app.theme === 'dark' ? '#495057' : '#dee2e6'
                                            }}
                                        >
                                            <div><strong>{t("entryWithBooking.warehouse", language)}:</strong> {item?.YmsWrh1.Descr1}</div>
                                            <div><strong>{t("entryWithBooking.bookingId", language)}:</strong> {item?.BookingId}</div>
                                            {item?.ArrivalId && <div><strong>Arrival ID:</strong> {item.ArrivalId}</div>}
                                            <div><strong>{t("ModalBooking.supplierTitleForm", language)}:</strong> {item?.SupDescr}</div>
                                            <div><strong>{t("ModalBooking.licenseNoTitleForm", language)}:</strong> {item?.YmsTrk1.LicenseNo}</div>
                                            <div><strong>{t("ModalBooking.driverTitleForm", language)}:</strong> {item?.YmsDri1.Name1}</div>
                                        </div>
                                    ))}
                                </div>
                                <PaginationControls
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={(newPage) => setCurrentPage(newPage)}
                                /></>
                        )}
                        <Form.Group className="mb-3">
                            <Form.Label>{t("ModalBooking.driverTitleForm", language)} <b className="required-bullet">*</b></Form.Label>
                            <div style={{ position: 'relative' }}>
                                {createAutoCompleteGeneric({
                                    objName: "Yms_Booking",
                                    rowIndex: null,
                                    disabledFieldsFlg: props.disabledFieldsFlg,
                                    columnConfig: {
                                        descr: "οδηγό",
                                        columnName: "YmsDri1.Name1",
                                        dropDownDisplay: "Name1",
                                        lookUpQuery: "{Yms_Drivers{DriverId Name1 DriverCode}}",
                                        secondaryField: "YmsDri1.DriverCode"
                                    },
                                    objectName: "Yms_Drivers",
                                    instanceName: "m_yms_drivers",
                                    lookupPrimaryField: "Name1",
                                    lookupSecondaryField: "DriverCode",
                                    setFieldsInBookingObj: (tmpObj, newEntry) => {
                                        tmpObj["Obj"].YmsDri1.Name1 = newEntry.Name1;
                                        tmpObj["Obj"].DriverId = newEntry.DriverId;
                                        tmpObj["Obj"].YmsDri1.DriverCode = newEntry.DriverCode;
                                    }
                                })
                                }
                                {hasDriverBan && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '42%',
                                        right: '10px',
                                        transform: 'translateY(-50%)',
                                        color: '#dc3545',
                                        fontSize: '1.2rem',
                                        pointerEvents: 'none'
                                    }}>
                                        <i className="bi bi-exclamation-lg"></i>
                                    </div>
                                )}
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("ModalBooking.dateTimeTitleForm", language)} <b className="required-bullet">*</b></Form.Label>
                            {CreatDatetime(bookingObj.Obj, "FromDate", "Yms_Booking", null, props.disabledFieldsFlg)}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("ModalBooking.phoneTitleForm", language)}</Form.Label>
                            {createTextBox(bookingObj.Obj, "Phone", "Yms_Booking", null)}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("entryWithBooking.stampTitleForm", language)}</Form.Label>
                            {createCheckBox(bookingObj.Obj, "StampFlg", "Yms_Booking", null)}
                        </Form.Group>

                    </Form>
                    <div className="header-form-new-booking m-0">
                        <h2>{t("ModalBooking.actionsHeader", language)}  <b className="required-bullet">*</b></h2>
                    </div>
                    <div className="tasks-container">
                        {bookingObj["Yms_BookingTasks"]?.length > 0 ? (
                            bookingObj["Yms_BookingTasks"].map((task, index) => (
                                <div className="task-item" key={task.BookingTaskId || index}>
                                    <div className="task-header">
                                        <span>
                                            <strong>{t('ModalBooking.actionsHeader', language)}: </strong>
                                            {
                                                task?.YmsTas1?.Descr1 || task?.YmsCat1?.Descr1 || task?.CountOfItems || task?.Pallets
                                                    ? [
                                                        task?.YmsTas1?.Descr1,
                                                        task?.YmsCat1?.Descr1,
                                                        task?.CountOfItems ? `${t('ModalBooking.itemCountTitleForm', language)}(${task.CountOfItems})` : null,
                                                        task?.Pallets ? `${t('ModalBooking.palletCountTitleForm', language)}(${task.Pallets})` : null
                                                    ].filter(Boolean).join(', ')
                                                    : t('ModalBooking.newTaskLabel', language)
                                            }
                                        </span>
                                        {task.isNewlyAdded && (
                                            <span className="delete-icon" onClick={(e) => { e.stopPropagation(); deleteTask(index); }}>
                                                <i className="bi bi-ban"></i>
                                            </span>
                                        )}
                                    </div>

                                    <Form className="mb-3">
                                        <Form.Group>
                                            <Form.Label>
                                                {t("ModalBooking.taskLabel", language)} <span className="required-bullet">*</span>
                                            </Form.Label>
                                            {createDropDownLookUpList(task, "YmsTas1.Descr1", "Yms_BookingTasks", index, !task.isNewlyAdded)}
                                        </Form.Group>
                                    </Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('ModalBooking.categoryTitleForm', language)}</Form.Label>
                                        {createDropDownLookUpList(task, "YmsCat1.Descr1", "Yms_BookingTasks", index, !task.isNewlyAdded)}
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('ModalBooking.itemCountTitleForm', language)}</Form.Label>
                                        {createTextBox(task, "CountOfItems", "Yms_BookingTasks", index, !task.isNewlyAdded)}
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('ModalBooking.palletCountTitleForm', language)}</Form.Label>
                                        {createTextBox(task, "Pallets", "Yms_BookingTasks", index, !task.isNewlyAdded)}
                                    </Form.Group>

                                    <hr />
                                </div>
                            ))
                        ) : (
                            <p className="text-muted">{t("calendarEvent.noActionsAdded", language)}</p>
                        )}
                        <Button className="button-add-task" style={{ marginBottom: "25px" }} onClick={addTask}>
                            <i className="bi bi-plus-circle"></i>  {t("ModalBooking.addTaskButton", language)}
                        </Button>
                    </div>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("entryWithBooking.commentTitleForm", language)}</Form.Label>
                        {createTextBoxCommends(bookingObj.Obj, "Notes", "Yms_Booking", null)}
                    </Form.Group>
                    <PhotoUpload
                        ref={photoUploadRef}
                        photoUrl={bookingObj?.Obj?.PhotoPath}
                        onImagesChange={handleImagesChange}
                        language={language}
                        serverUrl={serverUrl}
                        userToken={props.userToken}
                    />
                </>


            </div>
        </>
    );
}

export default EditBookingForm;
